export enum XrmRelationshipType {
  OneToMany = 0,
  ManyToMany = 1
}